import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useDeleteAllScenarioSafes = () => {
  const { invalidateQuery: invalidateCalculationQueries } = useInvalidateQueries(
    QueryKey.GET_CONVERSION_SUMMARY,
    QueryKey.CALC_CUSTOM_SAFE,
    QueryKey.CALC_SCENARIO_SAFES,
    QueryKey.CALC_SCENARIO_INVESTMENT,
  );

  const { mutate: deleteScenarioSafes, isPending } = useAppMutation(
    [QueryKey.DELETE_SCENARIO_SAFE],
    {
      mutationFn: ({ scenarioId }: { scenarioId: string }) =>
        ApiService.delete({
          endpoint: BackendRoute.SCENARIOS,
          routePath: [scenarioId, 'safe', 'remove-all'],
        }),
      onSuccess: () => {
        invalidateCalculationQueries();
      },
    },
  );
  return { deleteScenarioSafes, isPending };
};
